import { get } from 'lodash'

const types = {
  clinic: 'Clínica Médica',
  office: 'Consultório Médico',
  hospital: 'Hospital',
  laboratory: 'Labotarório',
  others: 'Outros'
}
const parseType = (type) => {
  return get(types, type, 'Outros')
}
export default {
  typeClinic (type) {
    return parseType(type)
  },
  bc () {
    return this.background || (this.dark ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.8)')
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/gadget/resources/computed.js